import { type PolicyDto, policyDtoStatusEnum } from 'korint-sdk';

// Mirrors COVERING_STATUSES in the backend's config-backed claims integration.
const CLAIMABLE_STATUSES: ReadonlySet<PolicyDto['status']> = new Set([
  policyDtoStatusEnum.POLICY_SIGNED,
  policyDtoStatusEnum.POLICY_STARTED,
  policyDtoStatusEnum.POLICY_STOPPED,
]);

export const isClaimablePolicyStatus = (status: PolicyDto['status']) =>
  CLAIMABLE_STATUSES.has(status);
